export const removeInlineColors = (html: string): string => {
  if (!html) return html;

  return html.replace(/style=["']([^"']*)["']/gi, (fullMatch, styleContent) => {
    const cleaned = styleContent
      .replace(/(?:^|;)\s*(color|background-color)\s*:\s*[^;]+/gi, "")
      .replace(/^\s*;\s*|\s*;\s*$/g, "")
      .trim();

    return cleaned ? `style="${cleaned}"` : "";
  });
};
